import httpClient from '../../services/httpClient';

export async function getUserEnums(
    names: string[],
    options = {failSilently: false}
): Promise<Record<string, string[]>> {
    try {
        const response = await httpClient.post('/v1/user-enums/query', {name: names});

        const enumsArray: { name: string; values: string[] }[] = response.data.data;

        // Convert array to object
        const returnedEnums: Record<string, { values: string[] }> = {};
        for (const item of enumsArray) {
            returnedEnums[item.name] = {values: item.values};
        }

        const result: Record<string, string[]> = {};
        const missing: string[] = [];

        for (const name of names) {
            if (returnedEnums[name]) {
                result[name] = returnedEnums[name].values;
            } else {
                missing.push(name);
            }
        }

        if (missing.length > 0) {
            if (options.failSilently) {
                console.warn(`Some enums were missing from the response: ${missing.join(', ')}`);
            } else {
                throw new Error(`Missing user enums: ${missing.join(', ')}`);
            }
        }
        return result;
    } catch (error: any) {
        console.error('Failed to fetch user enums:', error.message);
        throw new Error(`Failed to fetch user enums: ${error.message}`);
    }
}

export function getEnumName(baseEnumName: string, value: string): string {
    // if the base already contains “_sub_”, use only what comes after the last one
    const base = baseEnumName.includes("_sub_")
        ? baseEnumName.split("_sub_").pop()!
        : baseEnumName;

    const normalized = value
        .toLowerCase()
        .normalize("NFKD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");

    var result = `${base}_sub_${normalized}`;
    return result;
}


